import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {

  const user = localStorage.getItem('userInfo');

  return user ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute
